import axios from 'axios';
var API = axios.create({
    baseURL: process.env.VUE_APP_BACKEND_URL !== undefined ? process.env.VUE_APP_BACKEND_URL : 'http://localhost:3000',
    withCredentials: true
});
export var subsPending = function () {
    return API.get('/admin/clients/pending');
};
export var getClients = function (filters) {
    return API.post('/admin/clients/list', filters);
};
export var approveSub = function (id) {
    return API.patch('/admin/groups/subscription/approve/' + id);
};
